<template>
  <div class="el-col-24">
    <h5 class="warp-title">登录日志</h5>
    <el-form :inline="true" :model="searchForm" class="search" size="small" ref="searchForm">
      <el-form-item label="客服：">
        <el-input v-model="searchForm.customer" placeholder="请输入客服账号 / id / 姓名"></el-input>
      </el-form-item>
      <el-form-item label="操作类型：" style="margin-right: 25px">
        <el-radio-group v-model="searchForm.optType">
          <el-radio label="">全部</el-radio>
          <el-radio :label="key" v-for="(key, index) in Object.keys(optTypeConfig)" :key="index">{{ optTypeConfig[key].title }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="日期：">
        <div class="flex-common-style">
          <el-date-picker
            v-model="searchForm.startDate"
            type="date"
            placeholder="开始日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="compareTime(1)">
          </el-date-picker>
          <span style="margin: 0 5px">至</span>
          <el-date-picker
            v-model="searchForm.endDate"
            type="date"
            placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="compareTime(2)">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="onClear" v-if="querybtn.custome_login_query === 1">清空选项</el-button>
        <el-button size="small" @click="onExport" :loading="isExportLoading" v-if="querybtn.custome_login_export === 1">{{ isExportLoading ? '导出中' : '导出' }}</el-button>
        <el-button size="small" type="primary" @click="onSearch" :loading="isSearchLoading" v-if="querybtn.custome_login_query === 1">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      border
      align="center"
      style="width: 100%">
      <el-table-column
        align="center"
        prop="customerName">
        <template slot="header" slot-scope="scope">
          <i class="iconfont icon-yonghu"></i>
          <span>客服名</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="customerAccount">
        <template slot="header" slot-scope="scope">
          <i class="iconfont icon-zhanghaozhongxinzhanghaoguanli"></i>
          <span>客服账号</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center">
        <template slot="header" slot-scope="scope">
          <i class="iconfont icon-caozuo"></i>
          <span>操作类型</span>
        </template>
        <template slot-scope="scope">
          <el-tag size="mini" :type="optTypeConfig[scope.row.optType].style" v-if="optTypeConfig[scope.row.optType]">{{ optTypeConfig[scope.row.optType].title }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center">
        <template slot="header" slot-scope="scope">
          <i class="iconfont icon-zhongduan"></i>
          <span>操作终端</span>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.terminal === 1">Web</span>
          <span v-if="scope.row.terminal === 2">APP</span>
          <span v-if="scope.row.terminal === 3">H5</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-time"></i>
          <span>操作时间</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ip">
        <template slot="header" slot-scope="scope">
          <i class="iconfont icon-ip"></i>
          <span>IP</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="searchForm.currPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align='right'
      class="mt20"
      background>
    </el-pagination>
  </div>
</template>

<script>
import { queryButtonPermission } from '../../api/public/auth'
import {queryCustomerAccessRecord, exportCustomerAccessRecord} from '../../api/statistics/index'
export default {
  name: 'VisitLog',
  created () {
    this.queryButtonPermission()
  },
  data () {
    return {
      querybtn: {},
      isExportLoading: false,
      optTypeConfig: {
        1: {
          title: '登出',
          style: 'danger'
        },
        2: {
          title: '登录',
          style: 'success'
        },
        3: {
          title: '挂起',
          style: 'warning'
        },
        4: {
          title: '在线',
          style: 'success'
        }
      },
      tableData: [],
      total: 0,
      isSearchLoading: false,
      searchForm: {
        customer: '',
        optType: '',
        startDate: '',
        endDate: '',
        currPage: 1,
        pageSize: 10
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > (Date.now())
        }
      }
    }
  },
  methods: {
    // 查询页面权限
    queryButtonPermission () {
      let data = {
        id: global.$sider
      }
      queryButtonPermission(data).then((info) => {
        if (info.data.resultCode === 0) {
          this.querybtn = info.data.resultData
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    },
    // 导出
    onExport () {
      let params = {
        ...this.searchForm
      }
      delete params['currPage']
      delete params['pageSize']
      this.isExportLoading = true
      exportCustomerAccessRecord(params).then(res => {
        if (res.data.resultCode === 0) {
          window.open(res.data.resultData.fileDownLoadUrl)
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).finally(() => {
        this.isExportLoading = false
      })
    },
    // 对比筛选日期 开始日期>结束日期时 自动清空其中一天
    compareTime (type) {
      let startTimestamp = new Date(this.searchForm.startDate).getTime()
      let endTimestamp = new Date(this.searchForm.endDate).getTime()
      if (startTimestamp && endTimestamp && (startTimestamp > endTimestamp)) {
        type === 2 ? (this.searchForm.startDate = '') : (this.searchForm.endDate = '')
      }
    },
    // 清空选项
    onClear () {
      this.searchForm = {
        customer: '',
        optType: '',
        startDate: '',
        endDate: '',
        currPage: 1,
        pageSize: 10
      }
      this.initData()
    },
    // 查询
    onSearch () {
      this.searchForm.currPage = 1
      this.initData()
    },
    // 页码变化
    currentChange (val) {
      this.searchForm.currPage = val
      this.initData()
    },
    // 页容量变化
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.searchForm.currPage = 1
      this.initData()
    },
    // 初始化数据
    initData () {
      this.isSearchLoading = true
      queryCustomerAccessRecord(this.searchForm).then(res => {
        if (res.data.resultCode === 0) {
          this.tableData = res.data.resultData
          this.total = res.data.totalCount
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).finally(() => {
        this.isSearchLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Statistics/VisitLog.vue